'use client';

import { Text } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import Image from '@/app/_components/Image';
import JDPower2 from '@/public/2023011a.webp';
import JDPower1 from '@/public/2023063a.webp';
import Warranty from '@/public/6ddd0-warranty-WHITE-3.png';
import Award1 from '@/public/image-20240313-152544.png';
import Award2 from '@/public/image-20240313-152618.png';
import Award3 from '@/public/image-20240313-152716.png';
import Award4 from '@/public/image-20240313-152756.png';
import Img1 from '@/public/OOH-Banner1.jpg';
import Img2 from '@/public/OOH-Banner2.jpg';
import Img3 from '@/public/OOH-Banner3.jpg';
import Img4 from '@/public/OOH-Banner4.jpg';
import vehicle_slide16 from '@/public/vehicle_slider_16.webp';
import vehicle_slide19 from '@/public/vehicle_slider_19.webp';
import vehicle_slide23 from '@/public/vehicle_slider_23.webp';
import vehicle_slide33 from '@/public/vehicle_slider_33.webp';
import vehicle_slide39 from '@/public/vehicle_slider_39.webp';
import vehicle_slide41 from '@/public/vehicle_slider_41.webp';
import vehicle_slide42 from '@/public/vehicle_slider_42.webp';
import vehicle_slide9 from '@/public/vehicle_slider_9.webp';

import styles from './choose-kia.module.scss';
import { SwiperNavButtons } from './slider-nav/choose-kia-nav-button';

function ChooseKia() {
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return `<span class="${className} ${styles.customPaginationBullet}"></span>`;
    },
  };

  return (
    <>
      <Swiper
        className={styles.mySwiper}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={pagination}
      >
        <SwiperSlide className={styles.swiperSlide}>
          <Link
            href="https://www.kia.co.za/promotion/picanto"
            target="_blank"
            rel="noopener noreferrer"
            prefetch={false}
          >
            <Image src={Img1} alt="Bumper to bumper" title="Bumper to bumper" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className={styles.swiperSlide}>
          <Link
            href="https://www.kia.co.za/promotion/pegas"
            rel="noopener noreferrer"
            target="_blank"
            prefetch={false}
          >
            <Image src={Img2} alt="SA’s leading" title="SA’s leading" />
          </Link>
        </SwiperSlide>
        <SwiperSlide className={styles.swiperSlide}>
          <Link href="https://www.kia.co.za/" target="_blank" rel="noopener noreferrer" prefetch={false}>
            <Image src={Img3} alt="SA Premium" title="SA Premium"/>
          </Link>
        </SwiperSlide>
        <SwiperSlide className={styles.swiperSlide}>
          <Link
            href="https://www.kia.co.za/promotion/seltos"
            target="_blank"
            rel="noopener noreferrer"
            prefetch={false}
          >
            <Image src={Img4} alt="Win Midsize SUV" title="Win Midsize SUV" />
          </Link>
        </SwiperSlide>
        <SwiperNavButtons />
      </Swiper>
      <section className={styles.ooSelection01}>
        <Text as={'h1'}>
          Why Choose Kia? Because it is more than a brand. It is a global
          automotive powerhouse that continuously strives for - and delivers on
          - excellence in design, innovation, quality, reliability and
          durability. No matter which Kia model you choose or how long your
          journey may be: behind the wheel of a Kia, you will experience all
          this, and more.
        </Text>
      </section>
      <section className={styles.ooSelection02}>
        <div className={styles.awardWinImgWrap}>
          <div className={styles.awardWinImg}>
            <div className={styles.awardContent}>
              <p className={styles.mb3}>
                <b>Award-winning quality</b>
              </p>
              <p className={styles.awardCopy}>
                Don’t to take our word for it, it has been verified and
                substantiated by the numerous prestigious accolades the brand
                has received. Since 2015, Kia has ranked highest amongst mass
                market brands for initial quality in the authoritative J.D.
                Power U.S. Initial Quality Study (IQS). In fact, in 2015, it
                kicked the German powerhouse, Porsche, out of the number one
                spot, and then maintained that lead for six consecutive year.
                While Kia ranks 9th overall in the 2023 study, it says a lot
                that only three of the other top 10 brands are available in
                South Africa, at that Kia is still the highest-ranked mass
                market brand in the rankings.
              </p>
            </div>
            <Link
              href="https://www.jdpower.com/business/press-releases/2023-us-initial-quality-study-iqs"
              target="_blank"
              rel="noopener noreferrer"
              prefetch={false}
            >
              <Image src={JDPower1} alt="Kia" className={styles.JDPowerImg} />
            </Link>
          </div>
          <div className={styles.awardWinImg}>
            <div className={styles.awardContent}>
              <p className={styles.mb3}>
                <b>Award-winning reliability</b>
              </p>
              <p className={styles.awardCopy}>
                Our continuous desire to be the best of the best didn’t stop
                there. As of 2021, Kia also ranks highest for dependability in
                the J.D. Power Vehicle Dependability Study (VDS), proving that
                behind our multiple award-winning designs there is not only
                industry-leading quality, but also industry-leading reliability.
              </p>
            </div>
            <Link
              href="https://www.jdpower.com/business/press-releases/2023-us-vehicle-dependability-studyvds"
              target="_blank"
              rel="noopener noreferrer"
              prefetch={false}
            >
              <Image src={JDPower2} alt="Kia" className={styles.JDPowerImg} />
            </Link>
          </div>
        </div>
      </section>
      <section className={styles.ooSelection03}>
        <div className={styles.warrantyWrap}>
          <div className={styles.ooSelection03Img}>
            <Image src={Warranty} alt="Kia" className={styles.imgFluid} />
          </div>
          <div className={styles.ooSelection03Desc}>
            <p className={styles.mb3}>
              This is why all Kia vehicles sold in South Africa comes as
              standard with our bumper-to-bumper Unlimited Kilometre warranty.
              We’re so certain of our vehicles’ reliability that we encourage
              all Kia owners to get it and get out, to explore every part of
              South Africa as often as possible – because it doesn’t matter how
              far you go in the first five years of ownership; our warranty
              gives you peace of mind no matter how many kilometres you cover.
            </p>
            <p>
              But don’t trust us. Trust the experts when they tell you that Kia
              is leading by example. Whether you choose the evergreen Picanto or
              the adventure-ready Sonet, every Kia comes standard with the
              quality and reliability credentials that have made the Kia
              Sportage South Africa’s Midsize SUV of the Year, and the Sorento
              South Africa’s Premium SUV of the Year, in the 2023 South African
              Car of the Year competition.
            </p>
          </div>
        </div>
      </section>
      <section className={styles.awardListWrap}>
        <div className={styles.awardList}>
          <li>
            <Image
              src={Award1}
              className={`${styles.imgFluid} ${styles.mb3}`}
              alt="kia award"
              title="kia award"
            />
            <Link
              href="/blog/kia-breaks-records-in-j-d-power-awards"
              className={`${styles.btnDark} ${styles.dBlock}`}
              prefetch={false}
            >
              Learn more
            </Link>
          </li>
          <li>
            <Image
              src={Award2}
              className={`${styles.imgFluid} ${styles.mb3}`}
              alt="kia award"
              title="kia award"
            />
            <Link
              href="/blog/the-all-new-kia-sorento-go-boldly"
              className={`${styles.btnDark} ${styles.dBlock}`}
              prefetch={false}
            >
              Learn more
            </Link>
          </li>
          <li>
            <Image
              src={Award3}
              className={`${styles.imgFluid} ${styles.mb3}`}
              alt="kia award"
              title="kia award"
            />
            <Link
              href="/blog/the-best-of-the-best-kia-sportage-named-family-car-of-the-year-at-the-2024-cars-co-za-consumer-awards"
              className={`${styles.btnDark} ${styles.dBlock}`}
              prefetch={false}
            >
              Learn more
            </Link>
          </li>
          <li>
            <Image
              src={Award4}
              className={`${styles.imgFluid} ${styles.mb3}`}
              alt="kia award"
            />
            <Link
              href="https://financialservices.kia.co.za/warranties/warranty-kia/"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.btnDark} ${styles.dBlock}`}
              prefetch={false}
            >
              Learn more
            </Link>
          </li>
        </div>
      </section>
      <section className={`${styles.ooSelection04} ${styles.textCenter}`}>
        <p className={styles.mb3}>So, what are you waiting for?</p>
        <p>Choose Kia!</p>
      </section>
      <section className={styles.rangeSliderWrap}>
        <div className={styles.secTitle}>
          <h3 className={styles.fwBold}>View the range</h3>
        </div>
        <Swiper
          className={styles.rangeSwiper}
          modules={[Navigation, Autoplay]}
          spaceBetween={0}
          slidesPerView={6}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            991: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 5,
            },
            1120: {
              slidesPerView: 6,
            },
          }}
        >
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/picanto" prefetch={false}>
                  <Image src={vehicle_slide19} alt="Picanto" title="Picanto" />
                  <h3 className={styles.modelName}>Picanto</h3>
                </Link>
                <figcaption>
                  <h3>Picanto</h3>
                  <p>From R240 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/pegas" prefetch={false}>
                  <Image src={vehicle_slide42} alt="Pegas" title="Pegas" />
                  <h3 className={styles.modelName}>Pegas</h3>
                </Link>
                <figcaption>
                  <h3>Pegas</h3>
                  <p>From R292 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/sonet" prefetch={false}>
                  <Image src={vehicle_slide42} alt="Sonet" title="Sonet" />
                  <h3 className={styles.modelName}>Sonet</h3>
                </Link>
                <figcaption>
                  <h3>Sonet</h3>
                  <p>From R366 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/seltos" prefetch={false}>
                  <Image src={vehicle_slide39} alt="Seltos" title="Seltos" />
                  <h3 className={styles.modelName}>Seltos</h3>
                </Link>
                <figcaption>
                  <h3>Seltos</h3>
                  <p>From R472 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/sportage" prefetch={false}>
                  <Image src={vehicle_slide16} alt="Sportage" title="Sportage" />
                  <h3 className={styles.modelName}>Sportage</h3>
                </Link>
                <figcaption>
                  <h3>Sportage</h3>
                  <p>From R662 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/sorento" prefetch={false}>
                  <Image src={vehicle_slide41} alt="Sorento" title="Sorento" />
                  <h3 className={styles.modelName}>Sorento</h3>
                </Link>
                <figcaption>
                  <h3>Sorento</h3>
                  <p>From R948 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/carnival" prefetch={false}>
                  <Image src={vehicle_slide23} alt="Carnival" title="Carnival" />
                  <h3 className={styles.modelName}>Carnival</h3>
                </Link>
                <figcaption>
                  <h3>Carnival</h3>
                  <p>From R938 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/k2700" prefetch={false}>
                  <Image src={vehicle_slide9} alt="K2700" title="K2700" />
                  <h3 className={styles.modelName}>K2700</h3>
                </Link>
                <figcaption>
                  <h3>K2700</h3>
                  <p>From R376 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.rangeSlide}>
              <figure>
                <Link href="/new-cars/k2500" prefetch={false}>
                  <Image src={vehicle_slide33} alt="K2500" title="K2500" />
                  <h3 className={styles.modelName}>K2500</h3>
                </Link>
                <figcaption>
                  <h3>K2500</h3>
                  <p>From R424 995</p>
                </figcaption>
              </figure>
            </div>
          </SwiperSlide>
          <SwiperNavButtons range />
        </Swiper>
      </section>
    </>
  );
}

export default ChooseKia;
